import React from 'react';
import { AICoworkers } from '../components/AICoworkers';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// New Giga home screen. The hero is now the Slack-like interface — the
// "Ask Giga anything, get it done." narrative paired with the full Slack
// chat scene (LivesInSlack in hero mode), which leads the page. The minimal
// single-line composer hero was removed in favor of the Slack experience.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <LivesInSlack hero data-id="element-3802" />
      <AICoworkers isTasklet data-id="element-3803" />
      <HowItWorksConnections mode="how" data-id="element-3804" />
      <ComputerUse data-id="element-3805" />
      <CapabilityGrid data-id="element-3806" />
      <NarrativeSection data-id="element-3807" />
      <ToolComparison data-id="element-3808" />
      <WallOfLove data-id="element-3809" />
      <PricingSection data-id="element-3810" />
      <ClosingCTA data-id="element-3811" />
    </>;
}